import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { TbLockPassword, TbDeviceMobileCheck } from "react-icons/tb";
import { AiOutlineEyeInvisible } from "react-icons/ai";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import toast from "react-hot-toast";
import HttpClient from "../../Services/HttpClient";
import { useStore } from "../../zustand/useStore";

const Login = () => {
  const navigate = useNavigate();
  const { mobileNo } = useParams();
  const [mobile, setMobile] = useState(mobileNo ? mobileNo : "");
  const [password, setPassword] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [passIcon, setPassIcon] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { setRole, setPermissions } = useStore();

  const mobileRef = useRef(null);
  const passwordRef = useRef(null);

  const EyeIconPass = passIcon ? MdOutlineRemoveRedEye : AiOutlineEyeInvisible;

  const validatePassword = (pass) => {
    if (!pass) return "Enter password";
    if (!/[A-Z]/.test(pass)) return "Password must contain uppercase letters";
    if (!/[a-z]/.test(pass)) return "Password must contain lowercase letters";
    if (!/[0-9]/.test(pass)) return "Password must contain numbers";
    if (pass.length < 8) return "Password must be at least 8 characters";
    if (!/[!*@#%&()^~{}]/.test(pass))
      return "Password must contain a special character";
    return "";
  };

  const handleLogin = () => {
    let valid = true;

    // EMAIL VALIDATION
    if (mobile.length === 0) {
      setMobileError("Email is required");
      mobileRef.current.focus();
      valid = false;
    }
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mobile)) {
      setMobileError("Enter a valid email address");
      mobileRef.current.focus();
      valid = false;
    }
    else {
      setMobileError("");
    }


    // PASSWORD VALIDATION
    const passErr = validatePassword(password);
    if (passErr) {
      setPasswordError(passErr);
      if (valid) passwordRef.current.focus();
      valid = false;
    } else {
      setPasswordError("");
    }

    if (!valid) return;
    setIsLoading(true);

    let payload = new FormData();
    payload.append("email", mobile);
    payload.append("password", password);
    post(URLS.LOGIN, payload)
      .then((res) => {
        setIsLoading(false);
        if (res?.status == "success") {
          localStorage.setItem("token", res?.admin?.token);
          localStorage.setItem("admin_details", JSON.stringify(res?.admin));
          setRole(res?.admin?.role);
          setPermissions(res?.admin?.permissions);
          HttpClient.defaults.headers.common["Authorization"] =
            `Bearer ${res?.token}` || "";
          toast.success(res?.message);
          setTimeout(() => {
            navigate("/general-user");
          }, 500);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err", err);
      });
  };

  const keydownHandler = (event) => {
    if (event.key == "Enter") {
      handleLogin();
    }
  };

  // useEffect(() => {
  //   if (localStorage.getItem("token")) {
  //     navigate("/general-user");
  //   }
  // }, []);

  return (
    <div className="container-fluid">
      <div className="row vh-100">
        <div
          className="col-lg-6 col-md-6 col-12 p-0"
          style={{ height: "100vh" }}
        >
          <div
            style={{
              backgroundImage: "url(https://khyathi-bucket-store.s3.us-east-1.amazonaws.com/loginLogo.png)",
              backgroundSize: "100% 100%",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              height: "100%",
              width: "100%",
            }}
          ></div>
        </div>

        <div style={{ height: '100vh' }} className="col-lg-6 col-md-6 col-12 d-flex flex-column justify-content-end align-items-center bg-white text-white">
          <div className="w-60">
            <p className="text-black">welcome</p>
            <h2 className="mb-3 f8 text-left fs-5 text-black">KHYATHI LOGISTICS</h2>

            {/* MOBILE INPUT */}
            <div className="mb-3">
              <label className="form-label">Email ID</label>
              <div className="mb-3">
                <div className="position-relative mb-1">


                  {/* PASSWORD INPUT */}
                  <input
                    type="email"
                    className={`form-controlpass ${mobileError ? "border border-danger" : ""
                      }`}
                    placeholder="Enter your Email ID"
                    value={mobile}
                    ref={mobileRef}
                    onChange={(e) => {
                      setMobile(e.target.value);
                      setMobileError("");

                    }}
                    onKeyDown={keydownHandler}
                    style={{
                      borderRadius: "8px",
                      border: "1px solid #666",
                      height: "46px",
                      paddingLeft: "20px",
                      paddingRight: "20px",
                    }}
                  />
                </div>
                {mobileError && (
                  <small className="text-danger">{mobileError}</small>
                )}
              </div>
            </div>

            {/* PASSWORD INPUT */}
            <div className="mb-3">
              <label className="form-label">Password</label>
              <div className="mb-3">
                <div className="position-relative mb-1">


                  {/* PASSWORD INPUT */}
                  <input
                    type={passIcon ? "type" : "password"}
                    className={`form-controlpass ${passwordError ? "border border-danger" : ""
                      }`}
                    placeholder="Enter your password"
                    style={{
                      borderRadius: "8px",
                      border: "1px solid #666",
                      height: "46px",
                      paddingLeft: "20px",
                      paddingRight: "20px",
                    }}
                    value={password}
                    ref={passwordRef}
                    onKeyDown={keydownHandler}
                    onChange={(e) => {
                      setPassword(e.target.value);
                      setPasswordError(""); // LIVE VALIDATION
                      const error = validatePassword(e.target.value);
                      setPasswordError(error);
                    }}
                  />

                  {/* RIGHT ICON (TOGGLE EYE) */}
                  <EyeIconPass
                    onClick={() => setPassIcon(!passIcon)}
                    size={20}
                    className="position-absolute text-black"
                    style={{
                      top: "50%",
                      right: "12px",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      opacity: 0.7,
                    }}
                  />
                </div>
                {passwordError && (
                  <small className="text-danger">{passwordError}</small>
                )}
              </div>
            </div>

            <div className="text-end mb-3">
              <span
                onClick={() => {
                  navigate("/forget-password");
                }}
                className="text-black fs-6"
                style={{ cursor: "pointer" }}
              >
                Forgot Password?
              </span>
            </div>

            <button
              style={{ backgroundColor: "#259AF9" }}
              className="btn  w-100 text-white border-rounded  d-block py-2 fw-bold"
              onClick={handleLogin}
            >
              {isLoading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    style={{ color: "white", padding: 8 }}
                  ></span>
                </>
              ) : (
                "Login"
              )}
            </button>
          </div>
          <div
            style={{
              // backgroundImage: `url(${require("../../common/Assets/imgs/bgLogin.png")})`,
              background: "url(https://khyathi-bucket-store.s3.us-east-1.amazonaws.com/bgLogin.png)",
              height: "38%",
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }} className="w-100" ></div>
        </div>
      </div>
    </div>
  );
};

export default Login;
